import { useEffect } from "react";
import { useLocation } from "wouter";

/**
 * ScrollToTop hook — Serviway
 * Garante que cada mudança de rota faz scroll para o topo da página.
 */
export function useScrollToTop() {
  const [location] = useLocation();

  useEffect(() => {
    const hash = window.location.hash.slice(1);

    if (!hash) {
      window.scrollTo({ top: 0, behavior: "instant" });
      return;
    }

    const scrollToAnchor = () => {
      const target = document.getElementById(decodeURIComponent(hash));
      if (target) target.scrollIntoView({ behavior: "instant", block: "start" });
    };

    const frame = window.requestAnimationFrame(scrollToAnchor);
    return () => window.cancelAnimationFrame(frame);
  }, [location]);
}
